if (!window.Eurus.loadedScript.has('epicured-pdp-bundletab.js')) {
window.Eurus.loadedScript.add('epicured-pdp-bundletab.js');

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
         
    Alpine.data('xEpiBundleExpander', (
      accordionSectionId,     
      productId,
      variantId,
      sectionId    
    ) => ({    
      productId: productId,
      accordionSectionId: accordionSectionId, //id's the outer tab x-block-collapsible-tab-{{ block.id }}
      variantId: variantId,
      sectionId:sectionId,
      isBundle: false,
      debug:false,
      bundleItems:[],     
      initBundleExpander(){       
        this.debug && console.log('initBundleExpander');
       // this.queryBundleItems();
        this.queryRechargeBundleItems();
        //hits twice when variant changes.. hmm.. 
        document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e)=>{
            this.queryRechargeBundleItems(e.detail?.currentVariant?.id);
        });

      },
      async queryRechargeBundleItems(selectedVariant = null){
            const variant = document.querySelector('input[name="id"]')?.value  ?? selectedVariant ?? this.variantId; 
            this.debug && console.log('queryRechargeBundleItems ', variant);
            //we have a recharge storefront token.. right? 
            const bundleData = await window.epi_recharge_bridge.getBundleInfo(this.productId,variant);
            if(!bundleData || !bundleData.length) return; //not a bundle
            this.isBundle = true;             
            this.bundleItems = bundleData.map(_=>({
                node: { quantity: _.quantity, 
                productVariant: {
                    title: _.item.subtitle,
                    product:{
                        tags:[],
                        title: _.item.title,
                        onlineStoreUrl:'javascript:void(0);'
                    }
                }}
            }));
            //unhide the parent collapsible once we know its a bundle
            const el = document.querySelector('.' + accordionSectionId);  el && el.classList.remove('hidden');
      },
      async queryBundleItems(){
          this.debug && console.log('queryBundleItems');
         const query = 
         /* GraphQL */`
            query GetBundleItems {
                product(id: "gid://shopify/Product/${this.productId}") {   
                    variants(first: 1) {
                    edges {
                        node {
                        requiresComponents
                        components(first: 25) {
                            edges {
                                node {
                                    quantity
                                    productVariant {   
                                        title             
                                        product {                   
                                            title
                                            handle
                                            tags
                                            description
                                            onlineStoreUrl                    
                                        }
                                    }
                                }
                            }
                        }
                        }
                    }
                    }
                }
            }`
        const url = `https://${Shopify.shop}/api/2025-10/graphql.json`;

        fetch(url, {
            method:'POST',
            headers:{
                'Content-Type':'application/json',
                'Accept':'application/json',
                'X-Shopify-Storefront-Access-Token':window.STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({query})
        })
        .then(response=>response.json())
        .then(content=>{
            if(content.data.product.variants.edges[0].node.requiresComponents) this.isBundle = true;
            //this.isBundle = content.data.product.variants.edges[0].node.requiresComponents;        

            if(this.isBundle){
                this.bundleItems = content.data.product.variants.edges[0].node.components.edges;
                //until launch, the url will be null, we can shim it in (for the most part):
                for(let item of this.bundleItems){
                    if(!item.node.productVariant.product.onlineStoreUrl){
                        //const slug = item.node.productVariant.product.title.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
                        const slug = item.node.productVariant.product.handle;
                        item.node.productVariant.product.onlineStoreUrl = `/products/${slug}`;
                    }
                }
                const el = document.querySelector('.' + accordionSectionId);
                el && el.classList.remove('hidden');
            }  
            //1) need to show the variant options -- using edges[0] would be the ONLY variant if we remove the choice.
            //2) with choice, we need to know selected variant, hook change, and pick right one.. so we need more than first(1) variants.. and to find the right one.. big mess.

        }).catch(error=>{
            console.error('error fetching bundle components', error);
        });
      }
    }));
  
  });
});
}